import { ReactNode } from 'react'
import {
  Alert,
  Button,
  CircularProgress,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { Trans, useTranslation } from 'react-i18next'
import { StepActions, StepContent } from '../ReauthenticationDialog.style'

interface LinkStepProps {
  email: string
  notices: ReactNode
  isLinkResent: boolean
  isBusy: boolean
  isSendingLink: boolean
  onBack: () => void
  onResend: () => void
}

const LinkStep = ({
  email,
  notices,
  isLinkResent,
  isBusy,
  isSendingLink,
  onBack,
  onResend,
}: LinkStepProps) => {
  const { t } = useTranslation()

  return (
    <>
      <StepContent>
        <Stack spacing={2.5}>
          <DialogContentText variant="body2" color="text.secondary">
            <Trans
              t={t}
              i18nKey="reauthentication.linkSent"
              values={{ email }}
              components={[<strong key={0} />]}
            />
          </DialogContentText>
          {notices}
          {isLinkResent && (
            <Alert severity="success">{t('reauthentication.linkResent')}</Alert>
          )}
          <Stack
            direction="row"
            alignItems="center"
            gap={1.5}
            sx={{ color: 'grey.600' }}
          >
            <CircularProgress size={16} color="inherit" />
            <Typography variant="body2">
              {t('reauthentication.waitingForLink')}
            </Typography>
          </Stack>
        </Stack>
      </StepContent>
      <StepActions disableSpacing>
        <Button
          variant="outlined"
          onClick={onBack}
          disabled={isBusy || isSendingLink}
        >
          {t('reauthentication.goBack')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isSendingLink}
          disabled={isBusy}
          onClick={onResend}
        >
          {t('reauthentication.resendLink')}
        </LoadingButton>
      </StepActions>
    </>
  )
}

export default LinkStep
